module.exports = __webpack_public_path__ + "img/FQES02.7c34f97c.svg";